/* Mirrors Breakpoints.sm=640 (src/hooks/use-breakpoint.ts) and Spacing
   (src/constants/theme.ts).

   Desktop/tablet: a plain column of links. Phone: the column becomes an
   accordion row — title as the toggle, links hidden until opened. Done in CSS
   rather than with the JS breakpoint hook so the static HTML has its final
   layout at first paint, and so the links are always in the DOM (hidden, not
   unrendered) for crawlers. */

.col {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1 1 120px;
  min-width: 0;
  gap: 8px;
  padding-bottom: 32px;
}

.title {
  margin-bottom: 4px;
}

.toggle {
  display: none;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (max-width: 639px) {
  .col {
    flex-basis: 100%;
    gap: 0;
    padding-bottom: 0;
    border-top-width: 1px;
    border-top-style: solid;
  }

  .title {
    display: none;
  }

  .toggle {
    display: block;
  }

  .links {
    display: none;
    padding-bottom: 16px;
  }

  .open .links {
    display: flex;
  }
}
